/* eslint-disable no-console */
import { sleep } from '@flowus/common/async';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { IpcMessage } from '@flowus/shared';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useOpenModal } from 'src/common/components/next-modal';
import { publicLink } from 'src/common/const';
import { setDesktopState } from 'src/services/desktop';
import { ipcOnMessage, ipcSendMessage, isFlowUsApp } from 'src/utils/electron-util';
import { useDoubleClick } from '../page/use-double-click';
import { useAppVersion } from '../public/use-version';

/** 同步客户端的状态 */
export const useDesktopIpc = () => {
  const { t } = useAppTranslation();
  useDoubleClick();
  const appVersion = useAppVersion();
  const { pathname } = useLocation();
  const openModal = useOpenModal();

  // on message
  // useEffect(() => {
  //   ipcOnMessage(IpcMessage.HotUpdateComplete, () => {
  //     setAppUiState({ $readyUpdate: true });
  //     void updateDesktopVersion();
  //     const activityModalAnchor = createActivityModalAnchor();

  //     openModal.dropdown({
  //       popcorn: activityModalAnchor.popcorn,
  //       placement: 'top-start',
  //       offset: [0, 10],
  //       closeAfterCallBack: () => {
  //         activityModalAnchor.remove();
  //       },
  //       content: (_) => (
  //         <div className="next-modal p-5 flex flex-col space-y-4 w-72">
  //           <div className="text-t1-medium">新版已就绪</div>
  //           <div className="text-t4 text-grey3 space-y-2.5">
  //             问：为什么更新后没有新版本日志弹窗？
  //             <br />
  //             答：有弹窗是功能更新，没有则是漏洞修复
  //           </div>
  //           <Button
  //             colorType="active"
  //             onClick={() => {
  //               _.onCloseModal();
  //               ipcSendMessage(IpcMessage.Reload);
  //             }}
  //           >
  //             极速更新
  //           </Button>
  //         </div>
  //       ),
  //     });
  //   });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // 更新state
  useEffect(() => {
    ipcOnMessage(IpcMessage.UpdateDownloadComplete, () => {
      setDesktopState({ isUpdateReload: true });
    });
    ipcOnMessage(IpcMessage.UpdateAvailable, () => {
      setDesktopState({ isUpdateAvailable: true });
    });
    ipcOnMessage(IpcMessage.UpdateNotAvailable, () => {
      setDesktopState({ isUpdateAvailable: false });
    });
  }, []);

  // log
  useEffect(() => {
    // 检查更新
    ipcSendMessage(IpcMessage.CheckForUpdates);

    ipcOnMessage(IpcMessage.Log, (_, ...args) => {
      console.log(args);
    });

    ipcOnMessage(IpcMessage.Message, (_, ...args) => {
      console.log(args);
    });
  }, []);

  useEffect(() => {
    void sleep(5000).then(() => {
      if (appVersion) {
        const version = Number(appVersion.split('.').join(''));
        if (version >= 202) {
          return;
        }
        openModal.warning({
          modalId: 'update-desktop',
          title: t('hooks.desktop_ipc.client_update_available'),
          content: t('hooks.desktop_ipc.go_to_download', { version: '2.0.2' }),
          colorType: 'active',
          confirm: () => {
            window.open(publicLink.appDownload);
          },
        });
      }
    });
  }, [appVersion, openModal]);

  // 路由变化时的输出
  useEffect(() => {
    if (isFlowUsApp.check) {
      console.log(t('common.current_version'), appVersion);
      console.log(t('hooks.desktop_ipc.current_path'), pathname);
    }
  }, [appVersion, pathname, t]);
};
